// extracted by mini-css-extract-plugin
export default {"header":"VerifyModalScreen_header__CpTfj","title":"VerifyModalScreen_title__kOMER","headerSelect":"VerifyModalScreen_headerSelect__v7y1s"};